import { CartOrderApprovalRuleResult } from '../../../types/cart'
import React from 'react'
import { Notification } from '@local/do-secundo-notification'
import { useRestaurant } from '@local/do-secundo-restaurant-provider'
import { useFlags } from '@local/do-secundo-feature-flags'
import { LeadFormLink } from './CartValidation'
import { useCurrency } from '@local/do-secundo-use-currency'
import { t, Trans } from '@local/translations'

interface Props {
  rule: CartOrderApprovalRuleResult
}

export const OrderAmountRule: React.FC<Props> = ({ rule }) => {
  const { restaurantInfo } = useRestaurant()
  const { currencyFormatter } = useCurrency()
  const restaurantName = restaurantInfo?.name

  const { nvsCooLinkToLeadForm } = useFlags()

  return (
    <Notification
      severity='warning'
      isActionable={false}
      actionContent={t('order-amount-rule.add-to-order')}
    >
      <Trans
        i18nKey='order-amount-rule.restaurant-has-order'
        context={rule.ruleType === 'ORDER_LT' ? 'minimum-add' : 'limit-remove'}
        values={{
          restaurantName:
            restaurantName ?? t('order-amount-rule.the-restaurant'),
          thresholdAmount: currencyFormatter(rule.thresholdAmount),
          requiredAdjustment: currencyFormatter(rule.requiredAdjustment)
        }}
        components={{
          Additional: nvsCooLinkToLeadForm ? (
            <LeadFormLink />
          ) : (
            <>{t('order-amount-rule.have-questions-contact-us')}</>
          )
        }}
      />
    </Notification>
  )
}
